/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Action_CompleteInputs */

const en_us2_workout_logging_action_complete = /** @type {(inputs: Workout_Logging_Action_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete set`)
};

const pt_br2_workout_logging_action_complete = /** @type {(inputs: Workout_Logging_Action_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir série`)
};

const es_419_workout_logging_action_complete = /** @type {(inputs: Workout_Logging_Action_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar serie`)
};

const pt_pt2_workout_logging_action_complete = /** @type {(inputs: Workout_Logging_Action_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir série`)
};

const fr_fr2_workout_logging_action_complete = /** @type {(inputs: Workout_Logging_Action_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valider la série`)
};

const de_de2_workout_logging_action_complete = /** @type {(inputs: Workout_Logging_Action_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satz abschließen`)
};

const it_it2_workout_logging_action_complete = /** @type {(inputs: Workout_Logging_Action_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa serie`)
};

/**
* | output |
* | --- |
* | "Complete set" |
*
* @param {Workout_Logging_Action_CompleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_action_complete = /** @type {((inputs?: Workout_Logging_Action_CompleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Action_CompleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_action_complete(inputs)
	if (locale === "es-419") return es_419_workout_logging_action_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_action_complete(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_action_complete(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_action_complete(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_action_complete(inputs)
	return en_us2_workout_logging_action_complete(inputs)
});
export { workout_logging_action_complete as "workout-logging.action_complete" }